import { render, staticRenderFns } from "./GenieManualManager.vue?vue&type=template&id=54fc6a3a&"
import script from "./GenieManualManager.vue?vue&type=script&lang=js&"
export * from "./GenieManualManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports